import { Actions, setActiveEventId } from "@client/actions";
import { getEventId } from "@client/lib/cookie";
import { type AppState } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { type Dispatch, type MiddlewareAPI } from "redux";

export default (api: MiddlewareAPI<Dispatch, AppState>) => (next) => (action: ReduxAction<any>) => {
  next(action);

  switch (action.type) {
    case Actions.SsrInit:
    case Actions.InitSuccess: {
      const state = api.getState();
      const eventId = getEventId();
      const activeEventId = state.events.items.some((x) => x.id === eventId) ? eventId : null;
      api.dispatch(setActiveEventId(activeEventId));

      break;
    }
  }
};
